import {ApplicationConfig, ErrorHandler, inject, LOCALE_ID, provideAppInitializer, provideBrowserGlobalErrorListeners} from '@angular/core';
import {provideRouter, Router, withHashLocation} from '@angular/router';

import { routes } from './app.routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {httpInterceptor} from './core/interceptors/http-interceptor';
import {AuthService} from './core/auth/auth.service';
import {NavigationHistoryService} from './core/services/navigation-history.service';
import {TelemetryService} from './core/services/telemetry.service';
import * as Sentry from '@sentry/angular';

export const appConfig: ApplicationConfig = {
  providers: [
    {provide: LOCALE_ID, useValue: 'it-IT'},
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withHashLocation()),
    provideHttpClient(withInterceptors([
      httpInterceptor
    ])),
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
    provideAppInitializer(() => inject(AuthService).restoreSession()),
    provideAppInitializer(() => {
      inject(NavigationHistoryService);
    }),
  ]
};






